<script setup lang="ts">
import { useHomepage } from '~/composables/useHomepage'
import Anchor from '~/components/Anchor.vue'

const { contentBlocks } = await useHomepage()
</script>

<template>
  <section>
    <template
      v-for="{ id, component, data } in contentBlocks"
      :key="id"
    >
      <Anchor :id="id" />
      <Component
        :is="component"
        v-bind="data"
      />
    </template>
  </section>
</template>
